import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../store/store';
import {
  fetchDashboardStats,
  selectDashboardStats,
  selectDashboardLoading,
  selectDashboardError
} from '../../store/slices/dashboardSlice';
import styles from './Dashboard.module.css';

export const Dashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const stats = useSelector(selectDashboardStats);
  const isLoading = useSelector(selectDashboardLoading);
  const error = useSelector(selectDashboardError);

  useEffect(() => {
    dispatch(fetchDashboardStats());
  }, [dispatch]);

  // Valores por defecto si no hay datos o está cargando
  const displayStats = {
    totalVehicles: stats?.totalVehicles || 0,
    availableVehicles: (stats?.totalVehicles || 0) - (stats?.soldVehicles || 0),
    soldVehicles: stats?.soldVehicles || 0,
    lastActivity: stats?.lastActivity ? new Date(stats.lastActivity).toLocaleDateString() : '-',
  };

  if (isLoading && !stats) {
    return <div className={styles.loading}>Cargando estadísticas...</div>;
  }

  if (error) {
    return <div className={styles.error}>Error: {error}</div>;
  }

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.header}>
        <h1>Dashboard</h1>
        <p>Bienvenido al panel de control del concesionario</p>
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statIcon}>🚗</div>
          <div className={styles.statContent}>
            <h3>Total Vehículos</h3>
            <p className={styles.statNumber}>{displayStats.totalVehicles}</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>✅</div>
          <div className={styles.statContent}>
            <h3>Disponibles</h3>
            <p className={styles.statNumber}>{displayStats.availableVehicles}</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>📈</div>
          <div className={styles.statContent}>
            <h3>Vendidos</h3>
            <p className={styles.statNumber}>{displayStats.soldVehicles}</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>🕒</div>
          <div className={styles.statContent}>
            <h3>Última Actividad</h3>
            <p className={styles.statNumber}>{displayStats.lastActivity}</p>
          </div>
        </div>
      </div>

      <div className={styles.actionsGrid}>
        <Link to="/inventory" className={styles.actionCard}>
          <div className={styles.actionIcon}>📋</div>
          <h3>Ver Inventario</h3>
          <p>Gestiona el stock de vehículos</p>
        </Link>

        <Link to="/inventory/add" className={styles.actionCard}>
          <div className={styles.actionIcon}>➕</div>
          <h3>Agregar Vehículo</h3>
          <p>Registra un nuevo vehículo</p>
        </Link>

        <div className={styles.actionCard}>
          <div className={styles.actionIcon}>📊</div>
          <h3>Reportes</h3>
          <p>Ver estadísticas y reportes</p>
        </div>

        <div className={styles.actionCard}>
          <div className={styles.actionIcon}>⚙️</div>
          <h3>Configuración</h3>
          <p>Ajustes del sistema</p>
        </div>
      </div>

      <div className={styles.recentActivity}>
        <h2>Actividad Reciente</h2>
        <div className={styles.activityList}>
          <div className={styles.activityItem}>
            <span className={styles.activityIcon}>🆕</span>
            <div className={styles.activityContent}>
              <p className={styles.activityTitle}>Nuevo vehículo agregado</p>
              <p className={styles.activityTime}>Hace 2 horas</p>
            </div>
          </div>
          <div className={styles.activityItem}>
            <span className={styles.activityIcon}>✅</span>
            <div className={styles.activityContent}>
              <p className={styles.activityTitle}>Vehículo vendido</p>
              <p className={styles.activityTime}>Hace 5 horas</p>
            </div>
          </div>
          <div className={styles.activityItem}>
            <span className={styles.activityIcon}>✏️</span>
            <div className={styles.activityContent}>
              <p className={styles.activityTitle}>Información actualizada</p>
              <p className={styles.activityTime}>Ayer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

